import { useRouter, useSearchParams } from "next/navigation";

export default function BackButton() {
  const searchParams = useSearchParams();
  const router = useRouter();

  const handleBackClick = () => {

    const isHistory = searchParams.get("isHistory") || "";
    if (isHistory === "false") {
      // false이면 main 화면으로
      router.replace("/");
    } else {
      // parameter 에 isHistory 가 있으면
      router.back();
    }
  }

  return <>
    <button
      className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100"
      onClick={handleBackClick}
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-5 w-5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
      </svg>
    </button>
  </>;
}